// extracted by mini-css-extract-plugin
export default {"settings":"settings_settings__fPcfJ","focusable":"settings_focusable__mZipn","actionBtn":"settings_actionBtn__EcUNv","disabledBtn":"settings_disabledBtn__aUJIB"};